import { actionTypes } from '../common/constants/actionTypes';

export interface IHttpState {
  callCount: number;
  inProgress: boolean;
}

const newState = (): IHttpState => ({
  callCount: 0,
  inProgress: false,
});

export const httpReducer = (state = newState(), action: any) => {
  switch (action.type) {
    case actionTypes.HTTP_CALL_START:
      return handleHttpCallStart(state, action.payload);
    case actionTypes.HTTP_CALL_END:
      return handleHttpCallEnd(state, action.payload);
  }

  return state;
}

const handleHttpCallStart = (state: IHttpState, payload: any): IHttpState => ({
  callCount: state.callCount + 1,
  inProgress: true,
});

const handleHttpCallEnd = (state: IHttpState, payload: any): IHttpState => {
  const callCount = state.callCount - 1;

  return {
    callCount,
    inProgress: callCount > 0,
  };
};


// WEBPACK FOOTER //
// ./src/reducers/http.ts